<modal-pds3 [isOpen]="true" (userRequest)="handleUserRequest()" srLabelledBy="wk-modal__header-title">
    <div tabindex="-1">
        <vertical-layout-pds3 flowClass="wk-modal-container">
            <vertical-layout-header-pds3 flowClass="wk-modal__header">
                <h1 id="wk-modal__header-title" class="wk-modal__header-title">{{ title() | wkTranslate }}</h1>
                <div class="wk-modal__header-actions">
                    <button-field-pds3 type="icon" size="large" class="wk-modal__header-close">
                        <button (click)="close()" type="button" [disabled]="isUpdating()">
                            <icon-pds3 name="wk-icon-close" />
                            <sr-only-pds3>{{ "General.CloseModal" | wkTranslate }}</sr-only-pds3>
                        </button>
                    </button-field-pds3>
                </div>
            </vertical-layout-header-pds3>
            <vertical-layout-content-pds3 flowClass="wk-modal-content">
                @if (description()) {
                    <p>{{ description() | wkTranslate }}</p>
                }
                <ng-content />
            </vertical-layout-content-pds3>
            <vertical-layout-footer-pds3 flowClass="wk-modal__footer">
                @if (counter()) {
                    <div class="wk-modal__counter" role="status" aria-live="polite" aria-atomic="true">{{ counter() }}</div>
                }
                <div class="wk-modal__footer__actions">
                    @if (confirmAction(); as action) {
                        <button-field-pds3
                            type="primary"
                            [class]="`wk-modal__footer__action-submit wk-modal__footer__action--${action.type}`"
                            size="large"
                            [color]="action.type"
                        >
                            <button type="submit" (click)="submit()" [disabled]="isUpdating() || confirmDisabled()" [attr.aria-busy]="isUpdating()">
                                @if (action.icon) {
                                    <icon-pds3 [name]="action.icon" />
                                }
                                @if (isUpdating()) {
                                    <app-loader [isOverlay]="false" size="button" />
                                }
                                {{ action.title | wkTranslate }}
                            </button>
                        </button-field-pds3>
                    }
                    <button-field-pds3 type="text" class="wk-modal__footer__action-cancel" size="large">
                        <button #cancelButton type="button" [disabled]="isUpdating()" (click)="close()">{{ cancelActionTitle() | wkTranslate }}</button>
                    </button-field-pds3>
                </div>
            </vertical-layout-footer-pds3>
        </vertical-layout-pds3>
    </div>
</modal-pds3>
